import React, { FC } from 'react'
import {
    StyledHeaderLink,
    StyledSiteMapHeader,
    StyledSiteMapWrapper,
} from './SiteMap.styled'
import { SiteMapV4DTO } from '@west-australian-newspapers/publication-types'
import { SiteMapMonthDays } from './components/SiteMapMonthDays'
import { SiteMapYears } from './components/SiteMapYears'

export interface SiteMapProps {
    siteMapIndex: SiteMapV4DTO
}

export const SiteMap: FC<SiteMapProps> = ({ siteMapIndex }) => {
    const { indexType } = siteMapIndex

    const body =
        indexType === 'year' ? (
            <SiteMapYears siteMapIndex={siteMapIndex} />
        ) : (
            <SiteMapMonthDays siteMapIndex={siteMapIndex} />
        )
    return (
        <StyledSiteMapWrapper>
            <StyledSiteMapHeader>
                <StyledHeaderLink to="/sitemap">Site Map</StyledHeaderLink>
            </StyledSiteMapHeader>
            {body}
        </StyledSiteMapWrapper>
    )
}
